// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jkMms","label":"styles_label__1VC0n"};